import { ConfirmationModal, Dialog, useModalState } from '@cosuno/modal-frontend';
import {
  NavigationConfirmationPromptContext,
  useNavigationConfirmationPrompt,
} from '@cosuno/react-hooks';
import React, { type PropsWithChildren } from 'react';

import useTranslation from '~/shared/hooks/useTranslation';

const NavigationConfirmationPrompt: React.FC<PropsWithChildren<{}>> = ({ children }) => {
  const { t } = useTranslation();

  const { isDisplayed, cancel, discard, save, confirmNavigation } =
    useNavigationConfirmationPrompt();

  const modalState = useModalState({
    isOpen: isDisplayed,
  });

  return (
    <>
      <ConfirmationModal
        {...modalState}
        title={t('navigationConfirmation:title')}
        message={t('navigationConfirmation:message')}
        confirmText={t('navigationConfirmation:saveButton')}
        cancelText={t('common:cancel')}
        name="navigation-confirmation-prompt-modal"
        onConfirm={async ({ closeModal }) => {
          await save();
          closeModal();
        }}
        onCancel={() => cancel()}
        renderExtraButtons={() => (
          <Dialog.ControlButton hollow onClick={() => discard()}>
            {t('navigationConfirmation:discardButton')}
          </Dialog.ControlButton>
        )}
      />
      <NavigationConfirmationPromptContext.Provider value={{ confirmNavigation }}>
        {children}
      </NavigationConfirmationPromptContext.Provider>
    </>
  );
};

export default NavigationConfirmationPrompt;
